import { render, staticRenderFns } from "./PageOpportunityDetails.vue?vue&type=template&id=e884ece2"
import script from "./PageOpportunityDetails.vue?vue&type=script&lang=js"
export * from "./PageOpportunityDetails.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityDetails.vue?vue&type=style&index=0&id=e884ece2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports